export default [
  {
    value: "22BDB16B-AB8F-4203-9306-15579D1B6EA8",
    label: "Overall Student Growth Score",
  },
  { value: "E29FA9C9-CE11-4B5E-AF7E-F376E32A33C9", label: "VAM" },
  { value: "642E1C36-9987-424E-A492-CA084F3F105A", label: "Non-VAM" },
];
